import { render, staticRenderFns } from "./veStuAssocFundsStandard.vue?vue&type=template&id=01eedad7&scoped=true"
import script from "./veStuAssocFundsStandard.vue?vue&type=script&lang=js"
export * from "./veStuAssocFundsStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01eedad7",
  null
  
)

export default component.exports